import {
  ModalService,
  NotificationService,
  addActionBarItem,
  registerFormInputComponent,
} from "@vendure/admin-ui/core";
import { ProductMultiSelectorDialogComponent } from "./components/product-multi-selector-dialog/product-multi-selector-dialog.component";
import { ProductMultiSelectorFormInputComponent } from "./components/product-multi-selector-form-input/product-multi-selector-form-input.component";
import {
  AddToGoogleFeedDocument,
  GetAllProductsOnGoogleFeedDocument,
  ImportAllProductsOnGoogleFeedDocument,
} from "./generated/graphql";

export default [
  registerFormInputComponent(
    "product-multi-form-input-v2",
    ProductMultiSelectorFormInputComponent,
  ),
  addActionBarItem({
    requiresPermission: "SuperAdmin",
    label: "google-merchant.import-all-products",
    locationId: "product-list",
    id: "import-all-products-on-google-feed",
    onClick: (e, { injector, dataService, notificationService }) => {
      dataService
        .mutate(ImportAllProductsOnGoogleFeedDocument)
        .subscribe((d) => {
          notificationService.success("Products imported to Google Feed");
        });
    },
  }),
  addActionBarItem({
    requiresPermission: "SuperAdmin",
    label: "google-merchant.sync-google-feed",
    locationId: "product-list",
    id: "google-merchant-feed",
    onClick: (e, { injector, dataService }) => {
      const modalService = injector.get(ModalService);
      const notificationService = injector.get(NotificationService);
      dataService

        .query(GetAllProductsOnGoogleFeedDocument)
        .mapStream((res) => res)
        .subscribe((d) => {
          console.log("d", d);
          modalService
            .fromComponent(ProductMultiSelectorDialogComponent, {
              size: "xl",
              locals: {
                mode: "product",
                initialSelectionIds:
                  d?.getAllProductsOnGoogleFeed?.map((p) => String(p.id)) || [],
              },
            })

            .subscribe((data) => {
              if (!data) return;
              dataService
                .mutate(AddToGoogleFeedDocument, {
                  pids: data?.map((p) => p.productId) || [],
                })
                .subscribe((d) => {
                  notificationService.success("Product added to Google Feed");
                });
            });
        });
    },
  }),
];
